import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrigin = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 62,
	viewBox: "0 0 57 62",
	width: 57,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("filter", {
		id: "a",
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse",
		height: 64.5685,
		width: 64.5684,
		x: -4,
		y: -3,
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				result: "hardAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				in2: "BackgroundImageFix",
				mode: "normal",
				result: "effect1_dropShadow_2921_11284"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				result: "hardAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
			}),
			/* @__PURE__ */ _jsx("feMorphology", {
				in: "SourceAlpha",
				operator: "dilate",
				radius: 1,
				result: "effect2_dropShadow_2921_11284"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				in2: "effect1_dropShadow_2921_11284",
				mode: "normal",
				result: "effect2_dropShadow_2921_11284"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				in: "SourceGraphic",
				in2: "effect2_dropShadow_2921_11284",
				mode: "normal",
				result: "shape"
			})
		]
	}), /* @__PURE__ */ _jsxs("g", {
		filter: "url(#a)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "m14.142 14.1421c7.8105-7.81045 20.4738-7.81045 28.2843 0 7.8105 7.8105 7.8105 20.4738 0 28.2843l-14.1421 14.1421-14.1422-14.1421c-7.81044-7.8105-7.81044-20.4738 0-28.2843z",
			fill: "#fff"
		}), /* @__PURE__ */ _jsx("path", {
			d: "m28.2803 12.04c-3.214 0-6.3557.9531-9.028 2.7387-2.6723 1.7855-4.7551 4.3234-5.9851 7.2927-1.2299 2.9693-1.5517 6.2367-.9247 9.3889.627 3.1521 2.1747 6.0476 4.4473 8.3202s5.1681 3.8203 8.3203 4.4473 6.4195.3052 9.3888-.9247 5.5072-3.3128 7.2928-5.985c1.7855-2.6723 2.7386-5.8141 2.7386-9.0281-.0046-4.3083-1.7181-8.4389-4.7646-11.4854-3.0464-3.0465-7.1771-4.76-11.4854-4.7646zm6.3359 17.2782-8.125 5.625c-.1876.1297-.407.2056-.6347.2195-.2276.0139-.4547-.0347-.6567-.1406-.2019-.1059-.3711-.265-.4891-.4602-.118-.1951-.1804-.4188-.1804-.6469v-11.25c0-.228.0624-.4517.1804-.6469.118-.1951.2872-.3542.4891-.4601.202-.1059.4291-.1545.6567-.1406.2277.0139.4471.0898.6347.2195l8.125 5.625c.1663.115.3022.2686.3961.4477s.143.3782.143.5804-.0491.4014-.143.5805c-.0939.179-.2298.3327-.3961.4477z",
			fill: "#ffd36c"
		})]
	})]
});
export default SvgOrigin;
